module.exports = __webpack_public_path__ + "public/StoreIcon/pwdHidden.svg?f4a5c00a";